import { Component, OnInit } from '@angular/core';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { ProspectTourInfo } from 'app/models/prospect-tour-info';
import { Prospectregister } from 'app/models/prospectregister';
import { ErrorService } from 'services/error.service';
import { TelephoneNumber } from 'app/models/telephone-number';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-tour-prospect-verify',
  templateUrl: './tour-prospect-verify.component.html',
  styleUrls: ['./tour-prospect-verify.component.css']
})
export class TourProspectVerifyComponent implements OnInit {

  model: Prospectregister = new Prospectregister();
  errorMessage: string;
  tourType: string = null;
  proccessing: boolean = false;
  phoneNumber: TelephoneNumber = new TelephoneNumber('','','');

  constructor(private prospectService: ProspectService, private router: Router, private errorService: ErrorService, private splashService: SplashService) {
    this.model.LoadFromLocalTourQueryParams();

    let yardiID = localStorage.getItem('YardiID');
    let tourtype = localStorage.getItem('TourType');

    if (yardiID !== null && yardiID !== undefined)
    {
      this.model.PrimaryPOI = yardiID;
    }   
    
    if (tourtype !== null && tourtype !== undefined)
    {
      this.tourType = tourtype;
    }
   }

  ngOnInit() {
    if (this.tourType === "openhouse")
    {
      this.splashService.updateSplash("openhouse");
    }
    else if(this.tourType === "showing")
    {
      this.splashService.updateSplash("agenttour");
    }
    else if(this.tourType === "selftour")
    {
      this.splashService.updateSplash("selftour");
    }
  }

  onSubmit()
  {
    this.proccessing = true;
    this.model.CellPhone = this.phoneNumber.format();
    this.prospectService.CreateProspectFromTourLogin(this.model).subscribe(res => this.onProspectCreate(res), err => this.onCreateError(err));
  }

  onProspectCreate(res: any)
  {
    this.prospectService.getTourInfo(this.model.PrimaryPOI).subscribe(res => this.onGetTourInfo(res), res => this.onGetInfoError());
  }


  onCreateError(err: any)
  {
    this.proccessing = false;
    this.errorService.showError(err);
  }

  onGetInfoError()
  {
    this.proccessing = false;
    this.errorMessage = "Error verifying info.";
  }

  onGetTourInfo(info: ProspectTourInfo)
  {
    localStorage.setItem('PropertyAddress', info.Address);

    this.router.navigate(['/tour/agree']);
  }

}
